/**
 * Telefon-Anruf-Aktion für den Kunden-Screen (wie im Alt-Monolithen: 📞 in der Listenzeile,
 * „Anrufen" im Detail-Kopf). Auf dem Tablet in der Werkstatt antippen → Telefon wählt.
 *
 * Bewusst ein tel:-Link (kein reiner Text wie auf der Auftragskarte): Listenzeile und Detail-Kopf
 * sind keine Karten-Links auf eine andere Seite, ein <a> ist hier also gültig und gewollt.
 */

/** tel:-Ziel aus einer evtl. unsauber getippten Nummer: Nicht-Ziffern raus, führendes + bleibt. */
export function telHref(phone: string): string {
  const trimmed = phone.trim()
  const plus = trimmed.startsWith('+') ? '+' : ''
  return `tel:${plus}${trimmed.replace(/[^0-9]/g, '')}`
}

/** 16px-Telefon-Icon. SVG-Präsentationsattribute statt style= — bleibt unter der harten CSP zulässig. */
function PhoneGlyph() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  )
}

/** Kompakter Icon-Anruf-Link für die Listenzeile (Geschwister des Auswahl-Buttons, kein Verschachteln). */
export function CallIconLink({ phone, name }: { phone: string; name: string }) {
  return (
    <a className="wf-listrow__call" href={telHref(phone)} aria-label={`${name} anrufen`}>
      <PhoneGlyph />
    </a>
  )
}

/** „Anrufen"-Knopf im Detail-Kopf (Ghost-Button-Optik wie SOURCE). */
export function CallButtonLink({ phone, name }: { phone: string; name: string }) {
  return (
    <a className="wf-btn wf-btn--ghost wf-btn--sm wf-detailhead__call" href={telHref(phone)} aria-label={`${name} anrufen`}>
      <PhoneGlyph />
      Anrufen
    </a>
  )
}
